import React from "react";
import formatCurrency from "../../formatters/currency";

const StepPlanes = ({ planes, planesSeleccionados, setPlanesSeleccionados }) => {
  const toggleSeleccion = (planId) => {
    setPlanesSeleccionados((prev) =>
      prev.includes(planId)
        ? prev.filter((id) => id !== planId)
        : [...prev, planId]
    );
  };

  const renderGrupo = (titulo, tipoEsperado) => {
    const planesGrupo = planes.filter(
      (p) => p.tipoPlan?.toLowerCase() === tipoEsperado.toLowerCase()
    );

    if (planesGrupo.length === 0) return null;

    return (
      <div className="mb-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">{titulo}</h3>
        <div className="space-y-3">
          {planesGrupo.map((plan) => {
            const seleccionado = planesSeleccionados.includes(plan._id);

            return (
              <div
                key={plan._id}
                className={`flex items-start p-4 border rounded-xl cursor-pointer shadow-sm transition-all duration-200 ${
                  seleccionado ? "bg-green-100 border-green-500" : "bg-white"
                }`}
              >
                {/* Checkbox con label integrado */}
                <div className="flex items-center h-5 mr-3">
                  <input
                    id={`plan-${plan._id}`}
                    type="checkbox"
                    checked={seleccionado}
                    onChange={() => toggleSeleccion(plan._id)}
                    className="w-4 h-4 accent-green-600 cursor-pointer"
                  />
                </div>
                
                {/* Contenido del plan - ahora asociado al checkbox */}
                <label
                  htmlFor={`plan-${plan._id}`}
                  className="flex-grow cursor-pointer"
                >
                  <h4 className="text-gray-900 font-semibold text-md">
                    {plan.nombrePlan}
                  </h4>
                  <p className="text-sm text-gray-600">{plan.descripcion}</p>
                </label>
                
                <div className="text-right text-sm text-indigo-600 font-bold whitespace-nowrap">
                  {formatCurrency(plan.valor)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderGrupo("Retiro en Domicilio", "Retiro")}
      {renderGrupo("Entrega en Punto Drop off", "Entrega")}
    </div>
  );
};

export default StepPlanes;
